import { getUrlToWidget } from './get-url-to-widget';
export const getUrlToChannel = ({ siteUrl, compId }) => getUrlToWidget(siteUrl, compId);
//# sourceMappingURL=get-url-to-channel.js.map